import startCase from './start-case';

export default (type, asset) => {
  if (type === undefined || type === 'all') return 'All Assets';
  if (asset.length)
    return [startCase(type, false), startCase(asset, false)].join(': ');
  return `All ${startCase(type, false)}s`;
};
